import { useCallback, useEffect, useState } from 'react';
import { getReviews } from '../services/reviews';

function mapReview(review) {
  const quote = (review.comment || '').trim();
  if (!quote) return null;

  return {
    id: review.id,
    name: review.user_name?.trim() || 'Student',
    role: 'Student',
    avatar: review.user_profile_image_url || '',
    quote,
    rating: Number(review.rating) || 0,
  };
}

export function useReviews() {
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchReviews = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await getReviews();
      if (!res?.success) {
        throw new Error(res?.message || 'Failed to load reviews');
      }
      const list = (res?.data?.reviews || []).map(mapReview).filter(Boolean);
      setReviews(list);
    } catch (e) {
      setReviews([]);
      setError(e?.message || 'Failed to load reviews');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchReviews();
  }, [fetchReviews]);

  return { reviews, loading, error, refetch: fetchReviews };
}
